import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import React, { type FunctionComponent } from 'react';

import translations from './.vocab';

export const PricePanelError: FunctionComponent = () => {
  const { t } = useTranslations(translations);

  return <Text>{t('price-panel-error-text')}</Text>;
};
